module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 31
// module chunks = 0